(()=>{
  const root=document.querySelector('.wgr[data-wgr-pdp]');
  const bundles=document.getElementById('witsBundles');
  if(!root||!bundles)return;
  function update(){
    const selected=bundles.querySelector('.bundle.active')||bundles.querySelector('.bundle');
    if(!selected)return;
    const n=Number(selected.dataset.giftTins)||0;
    root.dataset.tins=String(n);root.dataset.unlocked=String(n>=3);
    const states={guide:n>=3?'included':'locked',shipping:n>=3?'included':'locked',five:n>=4?'replaced':n>=3?'included':'locked',ten:n>=4?'upgraded':'locked'};
    for(const [kind,state] of Object.entries(states)){
      const tile=root.querySelector(`[data-reward="${kind}"]`);
      tile.classList.remove('is-locked','is-replaced','is-upgraded');
      if(state!=='included')tile.classList.add('is-'+state);
      tile.querySelector('.wgr__status').textContent={locked:'🔒 Locked',included:'✓ Included',replaced:'Replaced',upgraded:'✧ Upgraded'}[state];
    }
  }
  bundles.addEventListener('click',()=>queueMicrotask(update));
  new MutationObserver(update).observe(bundles,{subtree:true,attributes:true,attributeFilter:['class']});
  update();
})();
